import { ValueOf } from '@ahha/utils/@types/typeUtils'

export const LICENSE_TIER = {
  NO_LICENSE: 'NO_LICENSE',
  PRO: 'PRO',
  TEAMS: 'TEAMS',
  OPS: 'OPS',
} as const

// 서버가 전달하는 라이센스 피처 코드
export const LICENSE_FEATURE_CODE = {
  PRO: 40001,
  TEAMS: 40002,
  OPS: 40003,
} as const

// PRO 라이센스의 조건부 피처 코드 (41001~41004)
export const CONDITIONAL_FEATURE_CODE = {
  IMAGE: 41001,
  TIME_SERIES: 41002,
  TABULAR: 41003,
  VIDEO: 41004,
} as const

export type LicenseTierType = ValueOf<typeof LICENSE_TIER>

// 소켓으로부터 받는 라이센스 체크 결과 페이로드
export interface CheckLicenseResultPayload {
  allFailed: boolean // true면 라이센스 키 없음
  passedFeatures: number[] // 통과한 기능 코드 (40001, 40002, 40003)
  failedFeatures: number[] // 실패한 기능 코드
  conditionalResult?: {
    // PRO(40001)일 때만 존재
    allFailed: boolean
    passedConditionalFeatures: number[] // 41001: 이미지, 41002: 시계열, 41003: 태뷸러, 41004: 비디오
    failedConditionalFeatures: number[]
  }
}

// localStorage에 저장되는 라이센스 정보
export interface LicenseInfo {
  tier: LicenseTierType
  passedFeatures: number[]
  conditionalFeatures?: number[]
}
